import deepForEach from "./deepForEach";

/**
 * Freezes the passed object and walks its properties to do a deep freeze.
 * Optionally you can provide an onEach method to also be ran on each value.
 * The onEach will be ran on each non-undefined value prior to freezing.
 * See deepForEach() for details onEach use.
 * The provided onEach will be use the "tailCall" method of deepForEach, and will
 * be ran before freezing.
 */
export default function deepFreeze<O extends object>(
	target: O,
	onEach?: (value: any | null | undefined, key: string | undefined) => O | null
): Readonly<O> {
	if (target === null || target === undefined) {
		return target;
	}

	return deepForEach(
		target,
		(value, key) => {
			if (onEach !== undefined) {
				value = onEach(value, key);
			}
			if (value !== undefined && value !== null) {
				value = Object.freeze(value);
			}
			return value;
		},
		true
	);
}
